import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ConnectorsTableApi } from "./ConnectorsTableApi";
import { ConnectorsTableconstant } from "./ConnectorsTableConstant";
import { ConnectorsTableParser } from "./ConnectorsTableParser";

function* getConnectorstable() {
  try {
    yield put({ type: ConnectorsTableconstant.CONNECTORS_TABLE_REQUEST });

    const res = yield call(ConnectorsTableApi.getConnectorsTable);


    const payload = ConnectorsTableParser.getConnectorsTableParser(res);

    yield put({
      type: ConnectorsTableconstant.CONNECTORS_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConnectorsTableconstant.CONNECTORS_TABLE_RESPONSE,
      payload: [],
    });
  }
}

function* postAddPowerMapSaga(payload) {
  try {
    yield put({ type: ConnectorsTableconstant.POST_POWER_MAP_REQUEST });

    const res = yield call(ConnectorsTableApi.postPowerMapApi, payload);


    yield put({
      type: ConnectorsTableconstant.POST_ADD_CHARGING_NETWORK_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConnectorsTableconstant.POST_POWER_MAP_RESPONSE,
      payload: [],
    });
  }
}

export function* registerConnectorstableSaga() {
  yield takeLatest(
    ConnectorsTableconstant.CONNECTORS_TABLE_SAGA,
    getConnectorstable
  );
  yield takeLatest(
    ConnectorsTableconstant.POST_POWER_MAP_SAGA,
    postAddPowerMapSaga
  );
}
